import { OnboardingFinalizedState } from '../enums/onboardingFinalizedState'
import { OnboardingPlatform } from '../enums/onboardingPlatform'
import { OnboardingVariant } from '../enums/onboardingVariant'

interface OnboardingVariantPayload {
  onboardingCurrentStep?: OnboardingFinalizedState
  onboardingPlatform: OnboardingPlatform
  onboardingVariant: OnboardingVariant
}

export const getOnboardingVariantPayload = (onboardingVariant: OnboardingVariant): OnboardingVariantPayload => ({
  onboardingPlatform: OnboardingPlatform.Web,
  onboardingVariant,
  ...(onboardingVariant === OnboardingVariant.Control && {
    onboardingCurrentStep: OnboardingFinalizedState.Skipped,
  }),
})
